import { useEffect, useState } from 'react';

/**
 * Which wizard mode is showing, as a module-level flag (null = closed).
 *
 * The wizard is an overlay on whatever page the user is on, so the button
 * that opens it (a sidebar entry, a navbar action, a card in a list) and the
 * single mounted instance (in the app layout) are nowhere near each other in
 * the tree.
 * ponytail: a store instead of a provider — nobody needs to wrap anything.
 * Hand-rolled subscribe because DMC/TO are still on React 17 (no
 * useSyncExternalStore).
 */
type WizardMode = 'create' | 'edit';

let mode: WizardMode | null = null;
const listeners = new Set<(mode: WizardMode | null) => void>();

const emit = () => listeners.forEach((listener) => listener(mode));

// Some hosts wire this straight to onClick, so anything that is not the
// literal 'edit' opens the create flow.
export function openTripWizard(nextMode?: unknown) {
  mode = nextMode === 'edit' ? 'edit' : 'create';
  emit();
}

export function closeTripWizard() {
  mode = null;
  emit();
}

export function useTripWizardMode(): WizardMode | null {
  const [current, setCurrent] = useState(mode);
  useEffect(() => {
    listeners.add(setCurrent);
    // A change between this render and the subscription would be missed.
    setCurrent(mode);
    return () => {
      listeners.delete(setCurrent);
    };
  }, []);
  return current;
}

export function useTripWizardOpen(): boolean {
  return useTripWizardMode() !== null;
}
